module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/d812682e79fabce77b61497d7872ca35.png";